webpackJsonp([85538871569801],{

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(21);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(16);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(14);
	
	__webpack_require__(13);
	
	var _reactLinkedinInsight = __webpack_require__(19);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/Damodaran.png";
	var icon2 = "https://winpeforum.com/assets/elements/RadhikaHaribhakti.jpg";
	var icon3 = "https://winpeforum.com/assets/elements/AshuSuyash.jpg";
	
	var duration = 400;
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    _this.Speaker2 = [{
	      imgUrl: icon1,
	      desc: "<div>\nM. Damodaran, IAS (Retd.), presently a governance consultant, advisor, mentor and coach, has worked\nwith the Union and the State governments in India, regulatory bodies, investment institutions, banks,\ndevelopment financial institutions and with the private sector. He has headed the highly successful\nrestructuring efforts in Unit Trust of India (UTI) and Industrial Development Bank of India (IDBI). He has\nbeen the Chairman of Securities and Exchange Board of India (SEBI). During his tenure at SEBI, he was\nelected Chairman of the EMC of the International Organisation of Securities Commission (IOSCO).\nHe has chaired high powered committees of the Government of India, Reserve Bank of India (RBI) and\nsome chambers of commerce. He has won several awards, including some for governance, leadership\nand transformation. He has been on the Boards of some of India\u2019s biggest companies and on the\n<br/><br/>\nAdvisory Boards of some foreign entities and is the Founder Chairman of Indian Institute of Management\n(IIM), Tiruchirappalli. He graduated with distinction in Economics and in Law from the Universities of\nMadras and Delhi respectively. He is widely acknowledged as one of India\u2019s foremost champions of\nCorporate Governance and is passionate about improving Board performance.\n \n          </div>",
	      name: "M. Damodaran",
	      post: "<div>Founder & Chairperson<br/> Excellence Enablers\n\n          </div>"
	    }];
	    _this.Speaker1 = [{
	      imgUrl: icon3,
	      desc: "<div>\n    Ashu Suyash is a seasoned leader with over 30 years of experience across Indian financial services and\nglobal information sectors. She is the Founder &amp; CEO of Colossa Ventures, an investment platform\nempowering women-led businesses with capital, capability, and confidence.<Br/><br/>\nShe serves as an independent director on the boards of Hindustan Unilever, Kotak Mahindra Bank, and\nTata Elxsi.<br/><br/>\nAshu is a strong sponsor of governance and best practices, and cares deeply about economic agency for\nwomen, affordable healthcare and right to education for all. She is a member of several Associations and\nCommittees in these areas. Ashu has received several awards and has been recognised among the Top\n50 Women in business in India. She is a Chartered Accountant and holds a bachelor&#39;s degree in\ncommerce from University of Mumbai.\n          </div>",
	      name: "Ashu Suyash",
	      post: "<div>Director on Boards\n          </div>"
	    }, {
	      imgUrl: icon1,
	      desc: "<div>\nM. Damodaran, IAS (Retd.), presently a governance consultant, advisor, mentor and coach, has worked\nwith the Union and the State governments in India, regulatory bodies, investment institutions, banks,\ndevelopment financial institutions and with the private sector. He has headed the highly successful\nrestructuring efforts in Unit Trust of India (UTI) and Industrial Development Bank of India (IDBI). He has\nbeen the Chairman of Securities and Exchange Board of India (SEBI). During his tenure at SEBI, he was\nelected Chairman of the EMC of the International Organisation of Securities Commission (IOSCO).\nHe has chaired high powered committees of the Government of India, Reserve Bank of India (RBI) and\nsome chambers of commerce. He has won several awards, including some for governance, leadership\nand transformation. He has been on the Boards of some of India\u2019s biggest companies and on the\n<br/><br/>\nAdvisory Boards of some foreign entities and is the Founder Chairman of Indian Institute of Management\n(IIM), Tiruchirappalli. He graduated with distinction in Economics and in Law from the Universities of\nMadras and Delhi respectively. He is widely acknowledged as one of India\u2019s foremost champions of\nCorporate Governance and is passionate about improving Board performance.\n \n          </div>",
	      name: "M. Damodaran",
	      post: "<div>Founder & Chairperson<br/> Excellence Enablers\n\n          </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>\n    Radhika Haribhakti has over 30 years of experience in commercial and investment banking, having\nworked with Bank of America, JM Morgan Stanley, and DSP Merrill Lynch. She has advised several giant\ncorporates and led their equity and debt offerings in domestic and international capital markets. She\ncurrently provides advisory services at RH Financial.\xA0<br/><br/>\nShe serves as an Independent Director on the Boards of Torrent Power, Bajaj Finance, Bajaj Finserv,\nICRA, NOCIL, and Data Link Investment Manager.<br/><br/>\n\nRadhika Haribhakti has been closely associated with women empowerment and financial inclusion and\nhas over 18 years of experience serving on non-profit boards. She is the former Chair of Friends of\nWomen&#39;s World Banking (FWWB) and Swadhaar FinAccess, two non-profits engaged in providing\nfinancial solutions to women in economically disadvantaged communities. She also previously served on\nthe Governing Council of Citigroup Micro Enterprise Award and CIl&#39;s National Committee on Women\nEmpowerment.\n          </div>",
	      name: "Radhika Haribhakti",
	      post: "<div>Director on Boards\n          </div>"
	    }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Connect with Winpe",
	        image: "https://winpeforum.com/assets/wob/banner.jpg",
	        description: "Join the Winpe WhatsApp groups to be a part of the largest community of women in PEVC. These groups allow women to connect, exchange insights with peers, stay updated on the latest PEVC market trends and hear about exclusive events.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "Connect with Winpe"
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              _react2.default.createElement(
	                "p",
	                null,
	                "Join the Winpe WhatsApp groups to be a part of the largest community of women in PEVC. These groups allow women to connect, exchange insights with peers, stay updated on the latest PEVC market trends and hear about exclusive events. It provides a safe space to discuss challenges, celebrate wins, support each other and openly discuss workplace issues, diversity challenges, and best practices in a trusted environment. Professionals also explore potential collaborations, co-investments, and partnerships. Plus, you\u2019ll always be in the loop on the latest from Winpe!",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Find the WhatsApp groups you want to join \u2014let\u2019s grow this network together!",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Join the Mumbai WhatsApp group to connect, collaborate, and network with women in PEVC across the city:",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Winpe Mumbai: "
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "a",
	                  { style: { color: '#bf2026' }, href: "https://chat.whatsapp.com/BT7Ju1vK1vBGMeIbUDpSkQ" },
	                  "https://chat.whatsapp.com/BT7Ju1vK1vBGMeIbUDpSkQ"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Join the Delhi WhatsApp group to connect, collaborate, and network with women in PEVC across the city:",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Winpe Delhi: "
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "a",
	                  { style: { color: '#bf2026' }, href: "https://chat.whatsapp.com/IPKFFU0P5PyH3HGZY8Cm9v" },
	                  "https://chat.whatsapp.com/IPKFFU0P5PyH3HGZY8Cm9v"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Join the Bangalore WhatsApp group to connect, collaborate, and network with women in PEVC across the city:",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Winpe Bangalore:"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "a",
	                  { style: { color: '#bf2026' }, href: "https://chat.whatsapp.com/Er0BSA3ObZsA2XSJwWN6Tl" },
	                  "https://chat.whatsapp.com/Er0BSA3ObZsA2XSJwWN6Tl"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  "Career Network Group "
	                ),
	                "Career Network Group is a part of Ignite by Winpe, a platform designed to support the female talent pipeline in the Private Equity and Venture Capital (PEVC) industry. ",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Ignite offers online career sessions, masterclasses, job vacancy information, and a profile bank of women interested in PEVC roles\u2014accessible to 30+ member firms in an anonymized format. So when PEVC firms hire, they can access our profile repository for candidates. The profile bank is open to women at all levels, including those already in PEVC and\u2013 as mentioned, we hide the candidate and firm names in the database that is shared with hiring firms. ",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Join the Winpe Career Network WhatsApp group to keep yourself updated on our career sessions, receive information on job openings which we keep posting there and join the Winpe Ignite profile repository.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Here is the link to the Winpe Career Network Group:",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "a",
	                  { style: { color: '#bf2026' }, href: "https://chat.whatsapp.com/JeAI8cBNsvSBtwY5jzNk6Y" },
	                  "https://chat.whatsapp.com/JeAI8cBNsvSBtwY5jzNk6Y"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  "Winpe Women on Boards"
	                ),
	                "Women on Boards is focused on strengthening boardrooms through greater representation of accomplished women leaders. The Women on Boards whatsapp group is a platform for sharing insights, updates, and relevant perspectives on board opportunities, governance, and regulatory developments.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Join the Women on Board whatsapp groups:",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "a",
	                  { style: { color: '#bf2026' }, href: "https://chat.whatsapp.com/Jlema24oL2sJ2aDUUFREDa?mode=gi_t" },
	                  "https://chat.whatsapp.com/Jlema24oL2sJ2aDUUFREDa?mode=gi_t"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null)
	              )
	            )
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-whatsappgroups-index-js-83ed3f36c65901cfd878.js